<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div>
  <fab-loading-spinner color="primary" [hidden]="!showSpinner"></fab-loading-spinner>
</div>
<div id="header-container">
  <h1 class="header-text">Manage Industry Scenarios</h1>
  <div>
    <button (click)="editIndustryScenario(selectedId)" class="action-button" color="primary"
            id="edit-button"
            [disabled]="selectedValue=== null"
            mat-flat-button>
      Edit
    </button>
    <button (click)="deleteIndustryScenario()" class="action-button" color="warn"
            id="delete-button"
            [disabled]="selectedValue=== null"
            mat-raised-button>
      Delete
    </button>
  </div>
</div>
<div [hidden]="noData" class="gfs-table">
  <ag-grid-angular
    style="height: 100%; width:100%;"
    class="ag-theme-quartz"
    [rowData]="industryScenarios"
    [columnDefs]="scenarioHeaders"
    [autoSizeStrategy]="autoSizeStrategy"
    [pagination]="true"
    [paginationPageSize]="pageSize"
    [paginationPageSizeSelector]="[20, 50, 100, 200, 2000]"
    [rowSelection]="rowSelection"
    [postSortRows]="postSortRows"
    (rowSelected)="onSelect($event)"
  />
</div>
